import { observable, action, computed } from 'mobx';

export class BalanceStore {
    constructor(botStore) {
        this.botStore = botStore;
    }

    @observable balances = [];

    @action listen() {
        this.botStore.socket.on('balances:update', ({ data }) => {
            this.setBalances(data);
        });
        this.getBalances();
    }

    @action setBalances(balances) {
        this.balances = Object.keys(balances).map(key => {
            return { id: key, ...balances[key] };
        });
    }

    getBalance(symbol) {
        return this.balances.filter(a => a.id === symbol)[0].free;
    }

    @action async getBalances() {
        const res = await this.botStore.proxy('cache/wallet_balances');
        this.setBalances(res);
    }

    @action close() {
        this.balances = [];
    }

    @computed get free() {
        return this.balances.filter(a => a.free > 0);
    }
}



// WEBPACK FOOTER //
// ./src/stores/BalanceStore.js